import { ColDef } from 'ag-grid-community';
import {
  MONTH,
  WORKING_HRS,
  BILLABLE_HRS,
  LEAVES_AVAILED,
  NO_OF_LEAVES,
  DURATION,
  TIMESHEET_STATUS,
  STATUS_FIELD,
  ATTACHMENT,
  CALENDAR_VIEW_ACTION,
  LEAVE_COMMENTS_FIELD,
} from '../../shared/components/table/table-field-definitions';
import { ActionConfig } from '../../shared/components/table/table-action-configs';
import { AttachmentRenderer } from '@shared/components/table/attachment-renderer/attachment-renderer.component';

// ============================================================================
// COLUMN DEFINITIONS (ColDef)
// ============================================================================

export const CONTRACTOR_LEAVES_ACTIONS: ColDef = {
  field: 'actions',
  headerName: 'Actions',
  minWidth: 100,
  maxWidth: 150,
  sortable: false,
  filter: false,
  pinned: 'right',
  autoHeight: true,
  cellStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cellRenderer: (params: any) => {
    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.height = '100%';

    const status = params.data?.status?.toLowerCase() || '';
    let isDisabled = status === 'cancelled';

    const cancelBtn = document.createElement('button');
    cancelBtn.title = 'Cancel Leave';
    cancelBtn.style.background = isDisabled ? '#6c757d' : '#003f2d';
    cancelBtn.style.border = isDisabled ? '1px solid #6c757d' : '1px solid #003f2d';
    cancelBtn.style.borderRadius = '4px';
    cancelBtn.style.cursor = isDisabled ? 'not-allowed' : 'pointer';
    cancelBtn.style.display = 'flex';
    cancelBtn.style.alignItems = 'center';
    cancelBtn.style.justifyContent = 'center';
    cancelBtn.style.padding = '6px 12px';
    cancelBtn.style.transition = 'all 0.2s';
    cancelBtn.style.color = '#ffffff';
    cancelBtn.style.fontSize = '14px';
    cancelBtn.style.fontWeight = '500';
    cancelBtn.style.opacity = isDisabled ? '0.6' : '1';
    cancelBtn.type = 'button';
    cancelBtn.textContent = 'Cancel';

    if (!isDisabled) {
      const parent = params?.context?.componentParent;
      if (parent?.checkTimesheetStatusForLeave instanceof Function) {
        parent.checkTimesheetStatusForLeave(params.data?.leaveStartDate).then((timesheetStatus: string) => {
          if (['pending approval', 'approved'].includes(timesheetStatus)) {
        Object.assign(cancelBtn.style, {
          background: '#6c757d',
          border: '1px solid #6c757d',
          cursor: 'not-allowed',
          opacity: '0.6',
        });
        isDisabled = true;
          }
        });
      }
    }

    cancelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!isDisabled) {
        const parent = params?.context?.componentParent;
        if (parent && typeof parent.onCancelLeave === 'function') {
          parent.onCancelLeave(params.data);
        }
      }
    });

    wrapper.appendChild(cancelBtn);
    return wrapper;
  },
};

export const CONTRACTOR_LEAVES_COLUMNS: ColDef[] = [
  NO_OF_LEAVES,
  DURATION,
  STATUS_FIELD,
  LEAVE_COMMENTS_FIELD,
  ATTACHMENT,
  CONTRACTOR_LEAVES_ACTIONS,
];

// ============================================================================
// CONTRACTOR TIMESHEET - COLUMN DEFINITIONS (ColDef)
// ============================================================================

export const CONTRACTOR_TIMESHEET_COLUMNS: ColDef[] = [
  MONTH,
  WORKING_HRS,
  LEAVES_AVAILED,
  BILLABLE_HRS,
  TIMESHEET_STATUS,
  CALENDAR_VIEW_ACTION,
];
// ============================================================================
// ACTION CONFIGURATIONS (ActionConfig)
// ============================================================================

export const VIEW_ACTION: ActionConfig = {
  action: 'view',
  label: 'View',
  icon: 'visibility',
  tooltip: 'View details',
  cssClass: 'btn-view',
};

// ============================================================================
// TABLE CONFIGURATIONS
// ============================================================================

export const LEAVE_TABLE_CONFIG = {
  columns: CONTRACTOR_LEAVES_COLUMNS,
  actions: [],
  enableRowSelection: false,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: false,
  paginationPageSize: 5,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const TIMESHEET_TABLE_CONFIG = {
  columns: CONTRACTOR_TIMESHEET_COLUMNS,
  actions: [],
  enableRowSelection: false,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: true,
  paginationPageSize: 25,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

// ============================================================================
// FRAMEWORK COMPONENTS
// ============================================================================

export const FRAMEWORK_COMPONENTS = {
  attachmentRenderer: AttachmentRenderer,
};
